import { render, staticRenderFns } from "./HospitalIntroJdsy.vue?vue&type=template&id=12ca5f22&scoped=true"
import script from "./HospitalIntroJdsy.vue?vue&type=script&lang=js"
export * from "./HospitalIntroJdsy.vue?vue&type=script&lang=js"
import style0 from "./HospitalIntroJdsy.vue?vue&type=style&index=0&id=12ca5f22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ca5f22",
  null
  
)

export default component.exports